var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.42143C2 6.42726 4.42726 4 7.42143 4H16.85C19.8442 4 22.2714 6.42726 22.2714 9.42143V15.0786C22.2714 18.0727 19.8442 20.5 16.85 20.5H7.42143C4.42726 20.5 2 18.0727 2 15.0786V9.42143ZM6.92857 8.82143C6.5972 8.5729 6.1271 8.64006 5.87857 8.97143C5.63004 9.3028 5.6972 9.7729 6.02857 10.0214L10.4857 13.3643C11.4635 14.0976 12.8079 14.0976 13.7857 13.3643L18.2429 10.0214C18.5742 9.7729 18.6414 9.3028 18.3929 8.97143C18.1443 8.64006 17.6742 8.5729 17.3429 8.82143L12.8857 12.1643C12.4413 12.4976 11.8302 12.4976 11.3857 12.1643L6.92857 8.82143Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9970aef091bbbe9f97d70bbbc8473243.svg";
export { ForwardRef as ReactComponent };